<div style="padding: 0px 12px">
    <div class="services-info-step-container" [id]="StepParentId">
        <div *ngIf="CurrentStep == Step.Step1">
            <div class="services-step-title">
                {{'EDIT_SERVICES.SERVICE_INFO.0' | translate}}
            </div>

            <div class="services-step-subtitle">
                {{'EDIT_SERVICES.SERVICE_INFO.1' | translate}}
            </div>

            <div class="product-cards-container" style="gap: 0px;">
                <div *ngFor="let product of getProductsCopy.controls; let first = first">
                    <div *ngIf="first" class="product-card-disabled">

                        <app-service-icons [isActiveRouteMap]="true"
                            [ServiceProductKey]="product.get('ProductKey')?.value"
                            [newServiceIcons]="true"></app-service-icons>
                        <span class="service_type_detail_text">{{
                            'PRODUCT_KEY_NAME.' + product.get('ProductKey')?.value | translate
                            }}</span>
                    </div>
                </div>
            </div>
            <div class="product-cards-container" *ngIf="ToppingList && ToppingList.length > 0">
                <div class="services-step-subtitle" style="margin-bottom: 14px;">
                    {{'EDIT_SERVICES.SERVICE_INFO.2' | translate}}
                </div>

                <div [ngClass]="{'product-card': EditableToppings.includes(topping.id) && isToppingSelected(topping)}"
                    class="product-card-diabled" *ngFor="let topping of ToppingList">
                    <img [src]="topping.icon" />
                    <div class="product-card-content toogle">
                        <div class="product-card-description">
                            <div>
                                <p>{{topping.id | translate}}</p>
                                <p class="product-card-specific"
                                    *ngIf="topping.id == ToppingIds.REFUELING || topping.id == ToppingIds.WASH ">
                                    <!-- {{getProductDetails(topping)}} -->
                                    {{ productDetailsMap[topping.id] }}
                                </p>
                            </div>

                            <p *ngIf="ModifyLinkList.includes(topping.id) && isToppingSelected(topping)"
                                (click)="modifyTopping(topping)" class="modify-topping-text">
                                {{'EDIT_SERVICES.SERVICE_INFO.4' | translate}}
                            </p>

                        </div>
                        <div *ngIf="EditableToppings.includes(topping.id)">
                            <app-toggle [isActive]="isToppingSelected(topping)"
                                (isActiveChange)="onActiveProductChange($event, topping)"></app-toggle>
                        </div>
                        <div *ngIf="!EditableToppings.includes(topping.id)">
                            {{'EDIT_SERVICES.SERVICE_INFO.8' | translate}}
                        </div>

                    </div>
                </div>
            </div>




        </div>
        <div *ngIf="CurrentStep == Step.Step2" [id]="StepContainerId">
            <app-fuel-charge-topping-step *ngIf="MainEditingTopping?.id == ToppingIds.REFUELING"
                [MainToppingData]="MainEditingTopping" [ProductsFormArray]="ProductsCopy"
                [ServiceForm]="ServiceForm"></app-fuel-charge-topping-step>

            <app-wash-topping-step *ngIf="MainEditingTopping?.id == ToppingIds.WASH"
                [MainToppingData]="MainEditingTopping" [ProductsFormArray]="ProductsCopy"
                [PossibleProductsIds]="PossibleWashProductsIds" [ServiceForm]="ServiceForm"></app-wash-topping-step>

        </div>

    </div>
</div>


<div class="footer-container">
    <button class="button-white button-padding-11 flex-1" (click)="backStep()">{{'EDIT_SERVICES.SERVICE_INFO.5' |
        translate}}</button>
    <button [ngClass]="{
        'button-disable':
          false
      }" class="button-black button-padding-11 button-image flex-1" (click)="nextStep()">
        {{CurrentStep == Step.Step1 ? ('EDIT_SERVICES.SERVICE_INFO.6' | translate) : ('EDIT_SERVICES.SERVICE_INFO.7' |
        translate)}}
        <img src="../../../../../../../../assets/icons/arrow-sm-right.svg" alt="arrow-right" />
    </button>

</div>